'use client'

import { useLayoutEffect, useRef } from 'react'
import { createNotebookStore } from './store'
import {
  clearActiveNotebookStore,
  setActiveNotebookStore,
} from './notebook-store-api'
import { NotebookStoreContext } from './notebook-store-context'
import { ActiveEditorProvider, deactivateActiveEditor } from './active-editor-context'
import { resetNotebookEditorSurface } from './tiptap-lifecycle'
import { isValidNotebookId } from './resolve-notebook-id'

export function NotebookStoreProvider({ notebookId, children }) {
  if (!isValidNotebookId(notebookId)) {
    return null
  }
  const storeRef = useRef(null)
  const notebookIdRef = useRef(null)

  if (!storeRef.current || notebookIdRef.current !== notebookId) {
    if (storeRef.current) {
      clearActiveNotebookStore()
      try {
        storeRef.current.getState().endNotebookSession()
      } catch {
        /* ignore */
      }
      deactivateActiveEditor()
      resetNotebookEditorSurface()
    }
    storeRef.current = createNotebookStore()
    notebookIdRef.current = notebookId
  }

  setActiveNotebookStore(storeRef.current)

  useLayoutEffect(() => {
    setActiveNotebookStore(storeRef.current)
    return () => {
      deactivateActiveEditor()
      resetNotebookEditorSurface()
    }
  }, [notebookId])

  return (
    <NotebookStoreContext.Provider value={storeRef.current}>
      <ActiveEditorProvider notebookId={notebookId}>
        {children}
      </ActiveEditorProvider>
    </NotebookStoreContext.Provider>
  )
}
